import { Alert, AlertDescription, Button } from '@geely/ui';

interface AppointmentActionsProps {
  status: string;
  onReschedule: () => void;
  onCancel: () => void;
}

export function AppointmentActions({ status, onReschedule, onCancel }: AppointmentActionsProps) {
  return (
    <>
      {status === 'pending' && (
        <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t">
          <Button onClick={onReschedule} className="flex-1">
            Remarcar
          </Button>
          <Button onClick={onCancel} variant="destructive" className="flex-1">
            Cancelar Agendamento
          </Button>
        </div>
      )}

      {status === 'cancelled' && (
        <Alert>
          <AlertDescription>
            Este agendamento foi cancelado. Para fazer um novo agendamento, volte à página inicial.
          </AlertDescription>
        </Alert>
      )}

      {['completed', 'customer_absent', 'in_progress'].includes(status) && (
        <Alert>
          <AlertDescription>
            Este agendamento não pode mais ser modificado devido ao seu status atual.
          </AlertDescription>
        </Alert>
      )}
    </>
  );
}
